// Copyright Epic Games, Inc. All Rights Reserved.

import enUs from "./en-US";
import deDe from "./de-DE";
import esEs from "./es-ES";
import esMx from "./es-MX";
import frFr from "./fr-FR";
import itIt from "./it-IT";
import jaJp from "./ja-JP";
import koKr from "./ko-KR";
import plPl from "./pl-PL";
import ptBr from "./pt-BR";
import ruRu from "./ru-RU";
import trTu from "./tr-TU";
import zhCn from "./zh-CN";
import zhTw from "./zh-TW";
import ar from "./ar";
import da from "./da";
import nl from "./nl";
import fi from "./fi";
import no from "./no";
import sv from "./sv";
import th from "./th";

export const initialLocalizationMessages = {
  "en-US": enUs,
  "de-DE": deDe,
  "es-ES": esEs,
  "es-MX": esMx,
  "fr-FR": frFr,
  "it-IT": itIt,
  "ja-JP": jaJp,
  "ko-KR": koKr,
  "pl-PL": plPl,
  "pt-BR": ptBr,
  "ru-RU": ruRu,
  "tr-TU": trTu,
  "zh-CN": zhCn,
  "zh-TW": zhTw,
  ar,
  da,
  nl,
  fi,
  no,
  sv,
  th,
};
